import { withPublicWrapper } from '../../components/public/Wrapper/withPublicWrapper';
import React from 'react';
import Head from 'next/head';
import useAdmin from 'services/firebase/hooks/useAdmin';
import { UserDetails } from 'components/public/Admin/UserDetails';
import { Summary } from 'services/hitchit/types/admin/Summary';
import { Container, Heading, SimpleGrid, Text } from '@chakra-ui/react';

const DashboardWithData = ({ summary }: { summary: Summary }): JSX.Element => {
  return (
    <Container maxW={'7xl'}>
      {/* <div>
        <pre>{JSON.stringify(baseUser, null, 2)}</pre>
      </div> */}
      <Heading lineHeight={1.1} fontWeight={600} fontSize={{ base: '2xl', sm: '4xl', lg: '5xl' }}>
        Total clients
      </Heading>
      <Text fontSize={{ base: '16px', lg: '18px' }} fontWeight={'500'} mb={'4'}>
        {`Number of active clients: ${summary.activeHikes}`}
      </Text>

      <Heading lineHeight={1.1} fontWeight={600} fontSize={{ base: '2xl', sm: '4xl', lg: '5xl' }}>
        Hike Overview
      </Heading>
      <SimpleGrid
        columns={{ base: 1, lg: 2 }}
        spacing={{ base: 8, md: 10 }}
        py={{ base: 18, md: 24 }}
      >
        {summary.usersSummary.map((userSummary) => {
          return <UserDetails key={userSummary.user.uid} userSummary={userSummary} />;
        })}
      </SimpleGrid>
    </Container>
  );
};
const AdminDashboard = (): JSX.Element => {
  const { userSummaryQuery } = useAdmin({ enableUserSummaryQuery: true });
  return (
    <>
      <Head>
        <title>Hitch and Hike - Admin Dashboard</title>
      </Head>
      {!userSummaryQuery?.error && !userSummaryQuery?.data && <div>Loading...</div>}
      {userSummaryQuery?.error && <div>Error: {userSummaryQuery?.error}</div>}
      {userSummaryQuery?.data && <DashboardWithData summary={userSummaryQuery?.data} />}
    </>
  );
};

export default withPublicWrapper(AdminDashboard);
